import { commonUtils } from '@/helpers/commonUtils'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useRef, useState } from 'react'
import styles from './VideoItem.module.less'

export interface VideoItemProps {
  src: string
  className: string
  status?: 'paused' | 'play'
  autoPlay?: boolean // 自动播放
  showPlayIcon?: boolean // 是否显示播放图标
  muted?: boolean
  style?: React.CSSProperties
  bilibiliVideoUrl?: string
}

export const VideoItem = observer(
  ({
    src,
    className,
    status = 'paused',
    style,
    muted = true,
    autoPlay = false,
    showPlayIcon = true,
    bilibiliVideoUrl,
  }: VideoItemProps) => {
    const [playStatus, setPlayStatus] = useState<'paused' | 'play'>(status)
    const video = useRef<HTMLVideoElement>(null)

    useEffect(() => {
      setPlayStatus(status)
    }, [status])

    useEffect(() => {
      if (video.current) {
        if (playStatus === 'play') {
          video.current?.play()
        } else {
          video.current?.pause()
        }
      }
    }, [playStatus])

    useEffect(() => {
      if (autoPlay) {
        setPlayStatus('play')
      }
    }, [autoPlay])

    return (
      <div className={classNames(styles.videoItem, className)} style={style}>
        {bilibiliVideoUrl && (
          <a
            href={bilibiliVideoUrl}
            target='_blank'
            className={styles.bilibiliVideoBox}
            rel='noreferrer'
          >
            查看更多视频教程
          </a>
        )}
        {playStatus === 'paused' && showPlayIcon && (
          <div
            className={classNames(styles.playIcon)}
            onClick={() => {
              setPlayStatus('play')
            }}
          >
            <img
              className={classNames(styles.icon)}
              src={commonUtils.getStaticFile('home-page-v1/icon__play.svg')}
            />
          </div>
        )}
        <video
          ref={video}
          src={src}
          muted={muted}
          autoPlay={autoPlay}
          loop
          webkit-playsinline='true'
          playsInline
          x5-video-player-type='h5'
          onLoad={(event) => {
            /** 解决 video 设置了 autoplay 之后仍然不生效的问题. */
            const target = event.target as HTMLVideoElement
            target.muted = muted
            target.play()
          }}
          onPlaying={() => {
            setPlayStatus('play')
          }}
          onPause={() => {
            setPlayStatus('paused')
          }}
          // 显示控件
          controls
        ></video>
      </div>
    )
  }
)
